import React, { FC } from 'react'

export interface SeperatorProps {
  orientation: 'horizontal' | 'vertical'
  size: string
  seperatorThickness: string
  seperatorStyle: string
  seperatorColor: string
  margin: string
  classes?: string[]
  style?: {}
}

const Seperator: FC<SeperatorProps> = props => {
  let styles = { ...props.style }
  let classes = props.classes?.join(' ')
  styles = { display: 'inline', ...props.style }
  if (props.orientation === 'horizontal') {
    styles = {
      borderTop: `${props.seperatorThickness} ${props.seperatorStyle} ${props.seperatorColor}`,
      margin: props.margin,
      width: props.size,
      ...styles
    }
  } else {
    styles = {
      borderLeft: `${props.seperatorThickness} ${props.seperatorStyle} ${props.seperatorColor}`,
      margin: props.margin,
      height: props.size,
      ...styles
    }
  }

  return <span className={classes} style={styles}></span>
}

export default Seperator
